import React from 'react'
import { Button, DownloadIcon, EditIcon } from '@diversioteam/diversio-ds'

import pdf from 'assets/Sales Representative Job Advert Revised.pdf'

import * as S from './completedCard.styles'

export const CompletedCard = () => {
    return (
        <S.CompletedCard>
            <S.Title>Your job posts are ready</S.Title>

            <S.Buttons>
                <Button
                    component="a"
                    href={pdf}
                    target="blank"
                    rightIcon={<DownloadIcon type="line" />}
                    color="primary"
                >
                    Download
                </Button>

                <Button color="secondary" onClick={() => {}} rightIcon={<EditIcon type="line" />}>
                    New Project
                </Button>
            </S.Buttons>
        </S.CompletedCard>
    )
}
